import React, { FC } from 'react'

import { IconContactlessPaymentProps } from './IconContactlessPayment.types'
import * as Styled from './styles/IconContactlessPayment.style'

import { nonThemeableRules } from '../../ruleSet'

const IconContactlessPayment: FC<IconContactlessPaymentProps> = ({
  size = nonThemeableRules.defaultSize as number as IconContactlessPaymentProps['size'],
  isResponsive = false,
}: IconContactlessPaymentProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M32.375 41.053a33.75 33.75 0 0 0 0-34.105m-7.19 3.527a25.883 25.883 0 0 1 0 27.055m-7.203-23.49a17.945 17.945 0 0 1 0 19.93'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M10.715 17.61a10.078 10.078 0 0 1 0 12.795' stroke='#fff' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconContactlessPayment
